<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Pharmacies</h1>
          </div>
          <div class="col-sm-2">
            <router-link v-if="hasPermission('pharmacy create')" style="margin-right: 10px" class="btn btn-primary"
              :to="{ name: 'create-pharmacy' }">create</router-link>
            <router-link v-if="hasPermission('pharmacy getSoftDeleted')" class="btn btn-success"
              :to="{ name: 'deleted-pharmacies' }">Deleted
              Pharmacy</router-link>
          </div>

        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="pharmacies.length > 0">

              <MyTable :columns="columns" :actions="true">
                <tr v-for="(pharmacy, index) in pharmacies" :key="index">
                  <th scope="row">{{ pharmacy.id }}</th>
                  <td>{{ pharmacy.name_ar }}</td>
                  <td>{{ pharmacy.name_en }}</td>
                  <!-- <td>{{ pharmacy.service_id ? pharmacy.service_id.name : '' }}</td> Check if service_id exists -->
                  <td>
                    <img :src="pharmacy.main_image" width="50" height="50" class="img-thumbnail" />

                  </td>
                  <!-- <td><img :src="`${assets}pharmacy.image`"></td> -->
                  <td>
                    <button class="me-2 btn btn-danger" v-if="hasPermission('pharmacy delete')"
                      @click="deletePharmacy(pharmacy.id)">
                      Delete
                    </button>
                    <router-link class="btn btn-primary spacing" v-if="hasPermission('pharmacy update')"
                      :to="{ name: 'edit-pharmacy', params: { id: pharmacy.id } }">
                      Edit
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No pharmacies found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'; // Import jQuery
import { store } from "../../Store";
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
import axios from "../../Axios";
export default {
  name: "AllPharmacies",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [],
      pharmacies: [],
      // service_id:"" ,
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
        { label: 'Image', key: 'main_image' },
      ],
    };
  },

  async created() {
    this.fetchPharmacies();
  },
  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },
  },
  // computed: {
  //   filteredPharmacies() {
  //     if (!this.searchTerm) {
  //       return this.pharmacies;
  //     }
  //     const term = this.searchTerm.toLowerCase();
  //     return this.pharmacies.filter(
  //       (pharmacy) =>
  //         pharmacy.name.toLowerCase().includes(term) ||
  //         pharmacy.postal_code.toLowerCase().includes(term)
  //     );
  //   },
  // },

  methods: {
    // fetch pharmacies
    async fetchPharmacies() {
      try {
        const response = await axios.get(
          `/admin/admin/pharmacy/all`
        );

        this.pharmacies = response.data.data;
        // this.service_id= response.data.data.service.id;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching pharmacies:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    deletePharmacy(id) {
      axios
        .delete(`/admin/admin/pharmacy/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchPharmacies();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};


</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>